import { __rest } from "tslib";
import React, { useEffect, useRef, useState, } from "react";
import { StyledButton } from "./styles";
import { hexToRgb } from "../../../utils/functions";
import { Spinner } from "../../Spinner/styles";
export var OrderButton = function (_a) {
    var title = _a.title, icon = _a.icon, textStyle = _a.textStyle, color = _a.color, inverted = _a.inverted, disabled = _a.disabled, isLoading = _a.isLoading, type = _a.type, onClick = _a.onClick, rest = __rest(_a, ["title", "icon", "textStyle", "color", "inverted", "disabled", "isLoading", "type", "onClick"]);
    var _b = useState(null), buttonWidth = _b[0], setButtonWidth = _b[1];
    var rgbColor = color
        ? hexToRgb(color)
        : undefined;
    var buttonRef = useRef(null);
    useEffect(function () {
        var _a;
        setButtonWidth(((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || null);
    }, []);
    return (React.createElement(StyledButton, { ref: buttonRef, style: rest, type: type, colorOption: rgbColor, inverted: inverted, disabled: disabled || isLoading, buttonWidth: buttonWidth, onClick: function (e) {
            if (onClick) {
                onClick(e);
            }
        } }, isLoading ? (React.createElement("div", null,
        React.createElement(Spinner, { background: (rgbColor === null || rgbColor === void 0 ? void 0 : rgbColor.normal) || "#fff", inverted: inverted, size: 10, spinnerWidth: 2 }))) : (React.createElement(React.Fragment, null,
        icon && icon,
        title && React.createElement("span", { style: textStyle }, title)))));
};
//# sourceMappingURL=index.js.map